/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Polygon } from "../structure_scan/polygon";

export const protobufPackage = "scan_planner";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface PolygonPrism {
  polygon: Polygon | undefined;
  maxHeight: number;
  minHeight: number;
}

function createBasePolygonPrism(): PolygonPrism {
  return { polygon: undefined, maxHeight: 0, minHeight: 0 };
}

export const PolygonPrism = {
  encode(message: PolygonPrism, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.polygon !== undefined) {
      Polygon.encode(message.polygon, writer.uint32(10).fork()).ldelim();
    }
    if (message.maxHeight !== 0) {
      writer.uint32(21).float(message.maxHeight);
    }
    if (message.minHeight !== 0) {
      writer.uint32(29).float(message.minHeight);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PolygonPrism {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePolygonPrism();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.polygon = Polygon.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 21) {
            break;
          }

          message.maxHeight = reader.float();
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.minHeight = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PolygonPrism {
    return {
      polygon: isSet(object.polygon) ? Polygon.fromJSON(object.polygon) : undefined,
      maxHeight: isSet(object.maxHeight) ? globalThis.Number(object.maxHeight) : 0,
      minHeight: isSet(object.minHeight) ? globalThis.Number(object.minHeight) : 0,
    };
  },

  toJSON(message: PolygonPrism): unknown {
    const obj: any = {};
    if (message.polygon !== undefined) {
      obj.polygon = Polygon.toJSON(message.polygon);
    }
    if (message.maxHeight !== 0) {
      obj.maxHeight = message.maxHeight;
    }
    if (message.minHeight !== 0) {
      obj.minHeight = message.minHeight;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PolygonPrism>, I>>(base?: I): PolygonPrism {
    return PolygonPrism.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PolygonPrism>, I>>(object: I): PolygonPrism {
    const message = createBasePolygonPrism();
    message.polygon = (object.polygon !== undefined && object.polygon !== null)
      ? Polygon.fromPartial(object.polygon)
      : undefined;
    message.maxHeight = object.maxHeight ?? 0;
    message.minHeight = object.minHeight ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
